"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.dashboardFiltersApi = void 0;
const createApi_1 = require("../../helpers/createApi");
const post = (caller) => ({ accountId, payload }) => caller(`/accounts/${accountId}/dashboard-filters`).post(payload, { withResponse: true });
const patch = (caller) => ({ accountId, dashboardFilterId, payload }) => caller(`/accounts/${accountId}/dashboard-filters/${dashboardFilterId}`).patch(payload);
const get = (caller) => async ({ accountId }) => caller(`/accounts/${accountId}/dashboard-filters`).get();
exports.dashboardFiltersApi = (0, createApi_1.createAPIFactory)({
    post,
    patch,
    get,
});
//# sourceMappingURL=api.js.map